import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import { ButtonPopupType } from './constants';

interface NotificationButtonEditOrDeletePopUpProps {
    handleClick: (name: ButtonPopupType) => void;
}

const NotificationButtonEditOrDeletePopUp: FC<NotificationButtonEditOrDeletePopUpProps> =
    ({ handleClick }) => {
        return (
            <ListContainer>
                {[ButtonPopupType.EDIT, ButtonPopupType.Delete]?.map((item) => (
                    <ListItem key={item} onClick={() => handleClick(item)}>
                        {item}
                    </ListItem>
                ))}
            </ListContainer>
        );
    };
const ListContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
    overflow: 'auto',
    position: 'absolute',
    bottom: '120px',
    backgroundColor: aampeTheme.colors.white,
    borderRadius: aampeTheme.borderRadius.default,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    padding: aampeTheme.spacing4(2),
    zIndex: 11,
});
const ListItem = styled.span({
    cursor: 'pointer',
    fontSize: aampeTheme.size.font.default,
    lineHeight: aampeTheme.size.lineHeight.small,
    fontWeight: aampeTheme.weights.light,
    padding: aampeTheme.spacing4(2),
    '&:hover': {
        backgroundColor: aampeTheme.colors.bordersWG01,
        color: aampeTheme.colors.solidA01,
    },
});

export default NotificationButtonEditOrDeletePopUp;
